import { useCallback } from 'react';
import { log } from 'log';
import { prop } from 'ramda';
import { useGetPlayerTags } from 'server';
import { useDeviceSelector } from 'js/store/hooks';
import { useNavigate } from 'js/hooks/navigate';
import * as urlUtils from 'js/utils/url.util';

import { PAGES_NAME, TAG_NAME } from '../constants';

export const useRedirectAfterLogin = () => {
    const getPlayerTags = useGetPlayerTags();
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const navigateWithReplace = useNavigate({ replace: true });
    const { afterLoginUrl } = urlUtils.getURLParams(location.search);

    return useCallback(() => {
        if (!isDesktop || afterLoginUrl) {
            return;
        }

        getPlayerTags({ tagName: TAG_NAME })
            .then(({ tags = [] }) => {
                const currentPageName = urlUtils.getCleanUrl();
                const tagValue = tags.filter(tag => tag.name === TAG_NAME)[0]?.value;

                if (tagValue && currentPageName !== PAGES_NAME[tagValue] && Object.values(PAGES_NAME).includes(currentPageName)) {
                    navigateWithReplace(PAGES_NAME[tagValue]);
                }
            })
            .catch(error => log('error', error));
    }, [navigateWithReplace, afterLoginUrl, isDesktop, getPlayerTags]);
};
